import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


export default function LoginAlert() {
  const [open, setOpen] = React.useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{
      position: 'fixed',
      top: '0px',
      left: '50%',
      transform: 'translate(-50%, 0%)',
      // width: 400,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 10,
      p: 1,
      zIndex: 9999,
      display: open ? "block" : "none",
      textAlign: "center",
      backgroundColor: "#f1a9a9"
    }}>
      {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            لطفا وارد سایت شوید
          </Typography> */}
      <Typography id="modal-modal-description" sx={{ mt: 1 }}>
        برای استفاده از این بخش شما ابتدا باید وارد شوید
      </Typography>
      <Button variant="contained" color='warning' size='small' onClick={handleClose} >بستن پیام</Button>
    </Box>
  );
}